<template>
  <div>
    <div style="float: right">
      <datetime-range
        id="custom-datetime-range"
        :allow-clear="false"
        :default-value="datetimeRange"
        @ok="
          v => {
            datetimeRange = v
          }
        "
      ></datetime-range>
    </div>
    <div style="clear: both"></div>
    <div
      class="module-container"
      style="height: 370px; margin: 16px 1px 0 1px"
    >
      <log-chart-card :get-func="getTrendFunc" :datetime-range="datetimeRange"></log-chart-card>
    </div>

    <div class="module-container" style="min-height: 400px; margin: 16px 1px 0 1px">
      <div class="module-header" style="margin-bottom: 14px">
        详细日志表
      </div>
      <log-table :datetime-range="datetimeRange" :columns="columns" :get-func="getTableFunc"></log-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getDaMengAuditLogList, getDaMengAuditLogTrend } from '@/api/log'
import DatetimeRange from '@/components/DatetimeRange'
import LogChartCard from './modules/LogChartCard.vue'
import LogTable from './modules/LogTable.vue'

export default {
  name: 'DamengLog',
  components: {
    LogChartCard,
    DatetimeRange,
    LogTable
  },
  data () {
    return {
      datetimeRange: [moment().subtract(1, 'hour'), moment()],
      getTrendFunc: getDaMengAuditLogTrend,
      getTableFunc: getDaMengAuditLogList,
      columns: [
        {
          dataIndex: 'timestamp',
          title: '采集时间',
          width: 200,
          key: 'timestamp',
          scopedSlots: {
            customRender: 'timestamp'
          }
        },
        {
          dataIndex: 'hostip',
          title: 'IP 地址',
          width: 160,
          key: 'hostip',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'hostip'
          }
        },
        {
          dataIndex: 'userid',
          title: '用户 ID',
          width: 100,
          key: 'userid',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'userid'
          }
        },
        {
          dataIndex: 'username',
          title: '用户名',
          width: 160,
          key: 'username',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'username'
          }
        },
        {
          dataIndex: 'roleid',
          title: '角色 ID',
          width: 100,
          key: 'roleid',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'roleid'
          }
        },
        {
          dataIndex: 'rolename',
          title: '角色名',
          width: 160,
          key: 'rolename',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'rolename'
          }
        },
        {
          dataIndex: 'ip',
          title: 'IP 地址',
          width: 160,
          key: 'ip',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'ip'
          }
        },
        {
          dataIndex: 'schid',
          title: '模式 ID',
          width: 100,
          key: 'schid',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'schid'
          }
        },
        {
          dataIndex: 'schname',
          title: '模式名',
          width: 160,
          key: 'schname',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'schname'
          }
        },
        {
          dataIndex: 'objid',
          title: '对象 ID',
          width: 100,
          key: 'objid',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'objid'
          }
        },
        {
          dataIndex: 'objname',
          title: '对象名',
          width: 160,
          key: 'objname',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'objname'
          }
        },
        {
          dataIndex: 'operation',
          title: '操作类型名',
          width: 160,
          key: 'operation',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'operation'
          }
        },
        {
          dataIndex: 'succ_flag',
          title: '成功标记',
          width: 120,
          key: 'succ_flag',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'succFlag'
          }
        },
        {
          dataIndex: 'sql_text',
          title: 'SQL 文本',
          width: 200,
          key: 'sql_text',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'sqlText'
          }
        },
        {
          dataIndex: 'description',
          title: '描述信息',
          width: 200,
          key: 'description',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'description'
          }
        },
        {
          dataIndex: 'optime',
          title: '操作时间',
          width: 200,
          scopedSlots: {
            customRender: 'optime'
          }
        },
        {
          dataIndex: 'mac',
          title: 'MAC 地址',
          width: 180,
          key: 'mac',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'mac'
          }
        },
        {
          dataIndex: 'seqno',
          title: '节点号',
          width: 100,
          key: 'seqno',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'seqno'
          }
        },
        {
          dataIndex: 'bind_info',
          title: '绑定参数',
          width: 200,
          key: 'bind_info',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'bindInfo'
          }
        }
      ]
    }
  }
}
</script>

<style lang="less">
.module-container {
  position: relative;
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
}
</style>
